import { NavListItem, NavListSection } from "#root/components/nav-list";
import Sidebar from "#root/components/sidebar";
import { WithSidebar } from "#root/components/withSidebar";
import type { ReactNode } from "react";
import { MdOutlineAlarm, MdOutlineArticle, MdOutlineLink, MdOutlineShoppingCart, MdRssFeed } from "react-icons/md";
import { NavLink } from "react-router-dom";
import Layout from "../layout";

export type PlatformLayoutProps = Parameters<typeof Layout>["0"] & {
  marketplaceElements?: ReactNode;
  parserElements?: ReactNode;
  instanceElements?: ReactNode;
  cloudScheduleElements?: ReactNode;
  referenceElements?: ReactNode;
};

export default function ({
                           children,
                           instanceElements,
                           parserElements,
                           marketplaceElements,
                           cloudScheduleElements,
                           referenceElements,
                           ...props
                         }: PlatformLayoutProps) {
  return (
    <Layout {...props}>
      <WithSidebar>
        <Sidebar>
          <NavLink to="/admin/platform/newsrpm-marketplace">
            <NavListItem icon={MdOutlineShoppingCart}>NewsRPM Marketplace</NavListItem>
          </NavLink>
          {marketplaceElements ? <NavListSection>{marketplaceElements}</NavListSection> : null}
          <NavLink to="/admin/platform/newsrpm-parser">
            <NavListItem icon={MdRssFeed}>NewsRPM Parser</NavListItem>
          </NavLink>
          {parserElements ? <NavListSection>{parserElements}</NavListSection> : null}
          <NavLink to="/admin/platform/newsrpm-instance">
            <NavListItem icon={MdOutlineArticle}>NewsRPM Instances</NavListItem>
          </NavLink>
          {instanceElements ? <NavListSection>{instanceElements}</NavListSection> : null}
          <NavLink to="/admin/platform/cloudschedule">
            <NavListItem icon={MdOutlineAlarm}>CloudSchedule</NavListItem>
          </NavLink>
          {cloudScheduleElements ? <NavListSection>{cloudScheduleElements}</NavListSection> : null}
          <NavLink to="/admin/platform/reference">
            <NavListItem icon={MdOutlineLink}>Reference Data Platform</NavListItem>
          </NavLink>
          {referenceElements ? <NavListSection>{referenceElements}</NavListSection> : null}
        </Sidebar>
        {children}
      </WithSidebar>
    </Layout>
  );
}
